import { render, staticRenderFns } from "./tdsort.vue?vue&type=template&id=19f915e4"
import script from "./tdsort.vue?vue&type=script&lang=js"
export * from "./tdsort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports